import { useMemo } from 'react';
import Submitting from '../elements/Submitting';
import { useAIChatMessagesContext } from './context';

const SubmittedLoader = () => {
  const { hideAssistantMessage, messages, status } = useAIChatMessagesContext();
  const lastMessageRole = messages?.[messages.length - 1]?.role;
  const show = useMemo(() => status === 'submitted' && !hideAssistantMessage && lastMessageRole === 'user', [hideAssistantMessage, status, lastMessageRole]);
  if (!show) return null;
  return <Submitting />;
};

export default SubmittedLoader;
